<template>
  
  <div class="file_download" @click.stop="download">
    <a class="file_download_a" :href="href" target="_self"></a>
  </div>

</template>

<script>
  export default {
    name: 'file_download_index',
    data() {
      return {
        href: ''
      };
    },
    props: {
      editData: {
        type: Object,
        default: null
      }
    },
    watch: {
      editData: {
        handler: function(val) {
          this.formatData(val)
        },
        deep: true
      }
    },
    methods:{
      download(e){
        this.templet.clickTime(()=>{
          const a = $(e.target).children('.file_download_a');
          a[0].click();
        })
      },
      formatData(data) {
        let obj = data.fun.file_download
        if(typeof obj.url !== "undefined") {
          this.href = 'javascript:download("'+ obj.url +'","'+ obj.name +'");'
        }
      }
    },
    components:{
    },
    mounted(){
      this.formatData(this.editData)
    }
  }
</script>

<style scoped lang="scss">
  .file_download {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
  .file_download_a{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/set_link/components/file_download.vue